import { configLogLevel, isLoggingEnabled } from '../config/logger';
import { logLevelToInt, LogLevelType } from '../types/logger';

const logger = (logLevel: LogLevelType, ...args: unknown[]) => {
  if (!isLoggingEnabled) {
    console.log('LOGGING DISABLED');
    return;
  }
  if (logLevelToInt[logLevel] >= logLevelToInt[configLogLevel]) {
    console[logLevel](...args);
  }
};

export default logger;
